<span *ngIf="expireSoon" class="warning-icon hd-icon icon-md hd-icon-warning insight-icon-warning"></span>
<span [ngClass]="{ 'text-danger': licenceExpired, 'text-base-darker': !licenceExpired && !expireSoon, 'text-base-warning': expireSoon }" class="licence-status-text">{{
  licenceTypeCaption
}}</span>
<span *ngIf="licenceExpired" class="text-danger licence-status-text">{{
  'licenceInfoBar_Expired_Caption' | xsI18n
}}</span>

<div class="fill no-gutter top-buffer-xs bottom-buffer-xs barIndicator-container">
  <div class="display-table no-gutter fill">
    <div *ngIf="!barIndicator.showMetricInfoText" class="display-table-cell condensed text-left text-nowrap">
      <span>{{ barIndicator.metric }}</span>
    </div>
    <div *ngIf="!barIndicator.showMetricInfoText" class="display-table-cell condensed top text-right text-nowrap">
      <strong
        ><span *ngIf="!barIndicator.currentValueMetric">{{ barIndicator.maxValueText }}</span></strong
      >
      <strong
        ><span *ngIf="barIndicator.currentValueMetric">{{ barIndicator.currentValueText }}</span></strong
      >
    </div>
    <div *ngIf="barIndicator.showMetricInfoText" class="barIndicator-metric-value text-nowrap">
      <span>{{ barIndicator.metricInfoText }}</span>
    </div>
  </div>
</div>

<mat-progress-bar class="progress-bar" mode="determinate" [value]="barIndicator.percentValue"></mat-progress-bar>

<div *ngIf="barIndicator.showStats" class="barIndicator-showstats">
  <div class="remaining">
    <span class="barIndicator-label" [ngClass]="{ 'text-danger': barIndicator.showWarning && barIndicator.availableValue <= 0 }"
      >{{ 'license_info_page_remaining' | xsI18n }}: </span
    >
    <span [ngClass]="{ 'text-danger': barIndicator.showWarning && barIndicator.availableValue <= 0 }"
      >{{ 'license_info_page_days' | xsI18n:barIndicator.availableValue }}</span
    >
  </div>
  <div class="total">
    <span class="barIndicator-label">{{ 'license_info_page_total' | xsI18n }}: </span> 
    <span>{{ 'license_info_page_days' | xsI18n:barIndicator.maxValue }}</span>
  </div>
</div>
